import { getClientDetails } from "config";

export default function LogoIcon() {
  const clientURL = getClientDetails(window?.location?.origin);
  const logoSrc =
    clientURL?.ClientCode === "BBK"
      ? clientURL?.Favicon
      : clientURL?.Logo || "https://diba6h158qrm3.cloudfront.net/Logo/gnLibLogo.png";

  return (
    <img
      style={{ height: "100%", maxHeight: "35px" }}
      src={logoSrc}
      alt="Logo"
    />
  );
}

